import styled from 'styled-components';
/**
 * Used by [`ProgressStepperStep`](#/More%20components?id=progressstepperstep)
 * to display an icon or dot that reflects a step's status.
 *
 * @since 8.57.0
 */

export var StyledProgressStepperStepDot = /*#__PURE__*/styled.span.withConfig({
  displayName: "StyledProgressStepperStepDot",
  componentId: "c11n-8-64-0__sc-14yz4w3-0"
})([""]);